module.exports = __webpack_public_path__ + "img/calendar-clock.da877667.webp";